// extracted by mini-css-extract-plugin
export var qltooltipLauncher = "w_bQ";
export var qltooltipWrapper = "w_bP";